function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypegoogleSizelWeightfilled = function SvgTypegoogleSizelWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#type=google,_size=l,_weight=filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.688 16.369a19 19 0 0 0-.276-3.252H16.32v6.162h8.643a7.4 7.4 0 0 1-3.199 4.862v3.998h5.156c3.028-2.787 4.768-6.902 4.768-11.77",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.32 32.001c4.315 0 7.954-1.417 10.606-3.862L21.77 24.14c-1.435.976-3.286 1.528-5.444 1.528-4.174 0-7.714-2.816-8.983-6.602H2.022v4.121a16 16 0 0 0 14.298 8.813",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.337 19.067a9.6 9.6 0 0 1 0-6.126V8.82H2.022a16.01 16.01 0 0 0 0 14.368z",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.32 6.333a8.7 8.7 0 0 1 6.138 2.399l4.568-4.569A15.38 15.38 0 0 0 16.32.001c-6.05 0-11.582 3.41-14.298 8.819l5.315 4.121C8.6 9.149 12.146 6.333 16.32 6.333",
    style: {
      fill: "#ea4335"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "type=google,_size=l,_weight=filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    style: {
      fill: "#fff"
    }
  }))));
};
export default SvgTypegoogleSizelWeightfilled;